import { useMutation } from 'react-query';
import { LoginForm } from 'interfaces/auth';
import type { LoginResponse } from '@vendys/web-lib';
import { auth } from 'utils/auth';
import { clearByLogout, getLocalStorageAfterLogout, setLocalStorageAfterLogout } from 'utils/storages';

export const useLogin = () =>
  useMutation<LoginResponse, unknown, LoginForm & { autoLogin?: boolean }, unknown>(
    ['login'],
    (user) =>
      auth.login({
        username: user.username,
        password: user.password,
        autoLogin: user.autoLogin ?? false
      }),
    { retry: false }
  );

export const useLogout = () =>
  useMutation<void, unknown, void, unknown>(
    'logout',
    async () => {
      await auth.logout();
      const popupDontView = getLocalStorageAfterLogout();
      clearByLogout();
      setLocalStorageAfterLogout(popupDontView);
    },
    { retry: false }
  );
